import { Link, Text } from "@chakra-ui/react";

/**
 * @typedef {Object} Props
 * @property {import(".").StepperStep} step
 * @property {number} index
 * @property {(index: number) => void} setStepIndex
 *
 * @param {Props} props
 */
function StepTitle({ step, index, setStepIndex }) {
  return step.isEnabled?.() ? (
    <Link
      onClick={() => {
        setStepIndex(index);
      }}
      fontSize="1.25rem"
      fontWeight="bold">
      {step.title}
    </Link>
  ) : (
    <Text fontSize="1.25rem" fontWeight="bold">
      {step.title}
    </Text>
  );
}

export default StepTitle;
